<template>
  <el-button class="createdButton" type="primary" @click="onCreated()">{{value}}</el-button>
</template>

<script>
export default {
  props:['value'],
  created() {},
  methods: {
    onCreated() {
      this.$emit("onCreated");
    },
  },
};
</script>

<style scoped lang="scss">
.createdButton {
  width: 120px;
  height: 40px;
  border-radius: 6px;
  font-size: 15px;
}    
</style>
